import classNames from "classnames";
import { Text, Trust } from "@simplybusiness/mobius";
import { useLocale } from "../../hooks/useLocale";
import type { WithMetadata } from "../../pages";
import type { TrustBannerProps } from "./types";
import "./TrustBanner.css";

export const TrustBanner = ({
  componentName,
  variant,
  actions,
  className,
  ref,
  ...otherProps
}: WithMetadata<TrustBannerProps>) => {
  const classes = classNames("mobius", "mobius-trust-banner", className);
  const { locale } = useLocale();

  return (
    <div
      ref={ref}
      {...otherProps}
      {...(componentName ? { "data-component": componentName } : {})}
      {...(variant ? { "data-variant": variant } : {})}
      className={classes}
    >
      <div className="mobius-trust-banner__body">
        <Text className="mobius-trust-banner__copy">
          Insuring over 1 million small businesses worldwide.
        </Text>
        <Trust
          variant="micro-star"
          locale={locale}
          theme="light"
          height="24px"
        />
      </div>
    </div>
  );
};
